import { images } from "../constants";
import {
  ReasonSectionCard,
  ReasonSectionCardHeading,
  ReasonSectionCardHeadingDot,
  ReasonSectionRoot,
  ReasonSectionSystemImage,
  ReasonSectionText,
  ReasonSectionTitle,
} from "../styles";

export default function ReasonSection() {
  return (
    <ReasonSectionRoot>
      <ReasonSectionTitle>利用料無料の理由</ReasonSectionTitle>

      <ReasonSectionCard>
        <ReasonSectionCardHeading>
          <ReasonSectionCardHeadingDot />
          手数料0円の仕組み
        </ReasonSectionCardHeading>

        <ReasonSectionText>
          私たちは、物件を買う不動産会社からシステム利用料をいただくことで運営されています。
        </ReasonSectionText>

        <ReasonSectionSystemImage src={images.reasonSystem} alt="手数料0円の仕組み" />

        <ReasonSectionText>
          {"買い手ではない第三者として運営しているため、オーナー様の利益を削るような仲介手数料（\"3%＋6万円\"など）をいただく必要はありません。\n最初から最後まで、中立な立場で売却をサポートいたします。"}
        </ReasonSectionText>
      </ReasonSectionCard>
    </ReasonSectionRoot>
  );
}
